import React from 'react';
import { useTranslation } from 'react-i18next';
import { MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem } from 'mdb-react-ui-kit';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <MDBDropdown>
      <MDBDropdownToggle color='link' className='nav-link'>
       {i18n.language === 'el' ? '🇬🇷 EL' : '🇺🇸 EN'}
      </MDBDropdownToggle>
      <MDBDropdownMenu>
        <MDBDropdownItem link onClick={() => changeLanguage('en')}>
          🇺🇸
          English
        </MDBDropdownItem>
        <MDBDropdownItem link onClick={() => changeLanguage('el')}>
          🇬🇷
          Ελληνικά
        </MDBDropdownItem>
      </MDBDropdownMenu>
    </MDBDropdown>
  );
};

export default LanguageSwitcher; 